import { Check } from "lucide-react";

import Text from "../../../components/ui/Text";
import Touchable from "../../../components/ui/Touchable";
import cn from "../../../utils/cn";

export default function RadioButton({
  text,
  checked,
  onClick,
  multiple,
}: {
  text: string;
  checked: boolean;
  onClick: () => void;
  multiple?: boolean;
}) {
  const wrapperStyle = checked
    ? "border-pink2 bg-pink2"
    : "border-grey2 bg-white";
  const circleStyle = checked
    ? "border-orange bg-orange"
    : "border-grey2 bg-white";

  return (
    <Touchable
      className={cn(
        wrapperStyle,
        "flex h-12 w-full items-center justify-center gap-2 rounded-lg border-2 border-solid px-3 duration-300 ease-in-out",
      )}
      onClick={onClick}
    >
      <div
        className={cn(
          circleStyle,
          "flex size-5 shrink-0 items-center justify-center rounded-full border-2 border-solid duration-300 ease-in-out",
        )}
      >
        {checked ? (
          multiple ? (
            <Check className="size-4 text-white" />
          ) : (
            <div className="size-2.5 rounded-full bg-white" />
          )
        ) : null}
      </div>

      <Text className="flex-1 font-medium">{text}</Text>
    </Touchable>
  );
}
